import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import { BulletList, BulletListItem, ImageContainer } from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'
import { Interpolate } from '@doordash/lib-i18n'
import {
  DOORDASH_AUSTRALIA_STORE_URL,
  HELP_URL,
} from '../../../../../constants'
import { CarSafetyVehicleSafetyImage } from '../../images/CarSafetyVehicleSafetyImage'
import { CommonTextUrl } from '../../../../atoms/common-text-url'

export const CarVehicleSafetySection = () => {
  return (
    <SectionContainer>
      <ImageContainer>
        <CarSafetyVehicleSafetyImage />
      </ImageContainer>

      <Text styles={Text.Styles.Bold32}>
        {i18n.t(i18nKeys.safetyCourse_car_step2__next__vehicle_safety)}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_car_step2__vehicle_safety__driving_safely_helps_you_avoid_accidents_and_minimise_risk_to
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_car_step2__vehicle_safety__collision_avoidance_and_defensive_driving_techniques
        )}
      </Text>
      <BulletList>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_car_step2__vehicle_safety__always_wear_a_seatbelt
            )}
          </ContentText>
        </BulletListItem>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_car_step2__vehicle_safety__always_obey_the_road_rules_including_traffic_lights_speed_limits
            )}
          </ContentText>
        </BulletListItem>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_car_step2__vehicle_safety__be_aware_of_what_other_drivers_are_doing_and_expect
            )}
          </ContentText>
        </BulletListItem>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_car_step2__vehicle_safety__do_not_multitask_or_do_anything_that_distracts_your_attention
            )}
          </ContentText>
        </BulletListItem>
      </BulletList>

      <ContentText>
        <Interpolate
          i18n={i18n}
          i18nKey={
            i18nKeys.safetyCourse_car_step2__vehicle_safety__when_completing_orders_remember_you_dont_need_to_rush_the
          }
          components={[<CommonTextUrl url={HELP_URL} />]}
        />
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_car_step2__vehicle_safety__conditions)}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_car_step2__vehicle_safety__you_should_always_drive_to_the_road_conditions_and_in
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_car_step2__vehicle_safety__maintenance)}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_car_step2__vehicle_safety__your_car_should_be_up_to_a_road_worthy_standard
        )}
      </ContentText>
      <BulletList>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_car_step2__vehicle_safety__check_your_tyres_to_ensure_they_are_not_flat_and
            )}
          </ContentText>
        </BulletListItem>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_car_step2__vehicle_safety__test_your_lights_and_indicators_to_ensure_they_are_working
            )}
          </ContentText>
        </BulletListItem>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_car_step2__vehicle_safety__check_your_brakes_and_steering_are_functioning_correctly_and_engaging
            )}
          </ContentText>
        </BulletListItem>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_car_step2__vehicle_safety__regularly_check_your_fuel_and_make_sure_you_always_have
            )}
          </ContentText>
        </BulletListItem>
      </BulletList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_car_step2__vehicle_safety__phone_usage)}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_car_step2__vehicle_safety__research_shows_that_using_a_mobile_phone_while_driving_can000
        )}
      </ContentText>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_car_step2__vehicle_safety__when_using_navigation_apps_on_your_phone_match_this_to001
        )}
      </ContentText>
      <ContentText>
        <Interpolate
          i18n={i18n}
          i18nKey={
            i18nKeys.safetyCourse_car_step2__vehicle_safety__phone_mounts_are_available_in_the_doordash_store_at_doordashaustraliastorecom002
          }
          components={[<CommonTextUrl url={DOORDASH_AUSTRALIA_STORE_URL} />]}
        />
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(i18nKeys.safetyCourse_car_step2__vehicle_safety__parking_theft)}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_car_step2__vehicle_safety__be_mindful_of_the_potential_for_theft_when_picking_up
        )}
      </ContentText>
    </SectionContainer>
  )
}
